// Ultimate-skill power bands. See ADR 0008 §2.9 (canonical decision) and
// ADR 0007 §2.1 (source numeric table).
//
// Maps a job's `UltimateStrengthClass` (T1..T4 buckets) to a numeric band that
// callers (PR B Skill construction) sample to set damage / heal multipliers.
// Bands are pinned to ADR 0007 §2.1; T2 special "T2.5" jobs use the upper
// band via `options.t2Special` rather than extending the strength-class enum.
/**
 * Snapshot of ADR 0007 §2.1's numeric bands. Exposed as a const so test
 * fixtures can spot-check the table without reaching into the function.
 */
export const ULTIMATE_POWER_BANDS = {
    T1: { min: 1.0, mid: 1.05, max: 1.1 },
    T2_default: { min: 1.05, mid: 1.075, max: 1.1 },
    T2_special: { min: 1.15, mid: 1.175, max: 1.2 },
    T3: { min: 1.3, mid: 1.4, max: 1.5 },
    T4: { min: 1.6, mid: 1.8, max: 2.0 },
};
/**
 * Resolve the power band for a job's ultimate, given its strength class
 * (declared in the ultimate concept) and a `t2Special` flag for the 5
 * weak-sub jobs that target the upper "T2.5" band per ADR 0007 §2.1.
 */
export function ultimatePowerBand(strengthClass, options) {
    switch (strengthClass) {
        case 'weak':
            return ULTIMATE_POWER_BANDS.T1;
        case 'weak-sub':
            return options?.t2Special ? ULTIMATE_POWER_BANDS.T2_special : ULTIMATE_POWER_BANDS.T2_default;
        case 'mid':
            return ULTIMATE_POWER_BANDS.T3;
        case 'strong':
            return ULTIMATE_POWER_BANDS.T4;
    }
}
//# sourceMappingURL=ultimate-power.js.map